import { motion as m } from "motion/react";
import type { RoomView } from "../../shared/game-types.js";

/**
 * The round's ban board.
 *
 * Six categories go up, each team strikes one out, and the round's two are
 * drawn from what survives — so nobody plays a board their whole team least
 * wanted to face.
 */
export function BanBoard({ room }: { room: RoomView }) {
  return (
    <div className="banBoard">
      <header className="tvHead">
        <div className="tvHead__meta">
          <span className="chip chip--index">
            Round {room.round} of {room.roundCount}
          </span>
          <span className="chip">{room.offers.length} categories</span>
        </div>
        <h1 className="prompt display riso" data-text="Strike one out">
          Strike one out
        </h1>
      </header>

      <div className="banBoard__grid">
        {room.offers.map((offer, i) => (
          <m.div
            key={offer.id}
            className="themeCard teamTint"
            data-team={offer.bannedBy ?? "rose"}
            data-banned={offer.bannedBy ?? undefined}
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{
              delay: i * 0.04,
              type: "spring",
              stiffness: 260,
              damping: 22,
            }}
          >
            <div className="themeCard__label">{offer.label}</div>
            <div className="themeCard__size">{offer.topic}</div>
            {offer.bannedBy ? (
              <div className="themeCard__stamp">
                banned by {room.teams[offer.bannedBy].name}
              </div>
            ) : null}
          </m.div>
        ))}
      </div>

      <div className="banBoard__foot">
        {(["rose", "slate"] as const).map((teamId) => (
          <div
            key={teamId}
            className="banChip teamTint"
            data-team={teamId}
            data-done={room.bansRemaining[teamId] === 0}
          >
            {room.teams[teamId].name}
            {room.bansRemaining[teamId] === 0
              ? " · banned"
              : ` · ${room.bansRemaining[teamId]} to ban`}
          </div>
        ))}
      </div>
    </div>
  );
}
